var map = {
	"./acceleration.svg": 7210,
	"./braking.png": 3678,
	"./braking.svg": 2806,
	"./himidity.svg": 4333,
	"./impact.svg": 3988,
	"./mobile.svg": 1264,
	"./seatbelt.svg": 3094,
	"./tempperature.svg": 2412,
	"./video.svg": 9831,
	"./warning.svg": 6369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4034;